export enum Rights {

  A_NUT_CREATE = 'A_NUT_CREATE',
  A_NUT_READ = 'A_NUT_READ',
  A_NUT_ORDER = 'A_NUT_ORDER',
  A_NUT_DELETE = 'A_NUT_DELETE',

  A_NUT_EQUATION_READ = 'A_NUT_EQUATION_READ',
  A_NUT_EQUATION_CREATE = 'A_NUT_EQUATION_CREATE',
  A_NUT_EQUATION_DELETE = 'A_NUT_EQUATION_DELETE',

  A_NUT_CLASS_READ = 'A_NUT_CLASS_READ',
  A_NUT_CLASS_CREATE = 'A_NUT_CLASS_CREATE',
  A_NUT_CLASS_DELETE = 'A_NUT_CLASS_DELETE',
  A_VAR_CLASS_DELETE = 'A_VAR_CLASS_DELETE',

  A_VAR_VAL_UPDATE = 'A_VAR_VAL_UPDATE',
  A_VAR_VAL_READ = 'A_VAR_VAL_READ',

  A_VAR_READ = 'A_VAR_READ',
  A_VAR_CREATE = 'A_VAR_CREATE',
  A_VAR_ORDER = 'A_VAR_ORDER',
  A_VAR_DELETE = 'A_VAR_DELETE',
  A_VAR_IMPORT = 'A_VAR_IMPORT',

  A_VAR_CLASS_READ = 'A_VAR_CLASS_READ',
  A_VAR_CLASS_UPDATE = 'A_VAR_CLASS_UPDATE',
  A_VAR_CLASS_CREATE = 'A_VAR_CLASS_CREATE',

  A_REF_READ = 'A_REF_READ',
  A_REF_CREATE = 'A_REF_CREATE',
  A_REF_NUT_UPDATE = 'A_REF_NUT_UPDATE',
  A_REF_DELETE = 'A_REF_DELETE',

  A_REF_EQUATION_READ = 'A_REF_EQUATION_READ',
  A_REF_EQUATION_CREATE = 'A_REF_EQUATION_CREATE',
  A_REF_EQUATION_DELETE = 'A_REF_EQUATION_DELETE',

  A_MOD_READ = 'A_MOD_READ',
  A_MOD_CREATE = 'A_MOD_CREATE',
  A_MOD_ASSOCIATENUT = 'A_MOD_ASSOCIATENUT',
  A_MOD_DELETE = 'A_MOD_DELETE',

  A_USR_READ = 'A_USR_READ',
  A_USR_CREATE = 'A_USR_CREATE',
  A_USR_DELETE = 'A_USR_DELETE',
  A_USR_SET_VALIDITY = 'A_USR_SET_VALIDITY',
  A_USR_ROLE = 'A_USR_ROLE',
  A_USR_ENTITY = 'A_USR_ENTITY',

  A_ROLE_READ = 'A_ROLE_READ',
  A_ROLE_CREATE = 'A_ROLE_CREATE',
  A_ROLE_DELETE = 'A_ROLE_DELETE',

  A_FNCT_READ = 'A_FNCT_READ',
  A_FNCT_CREATE = 'A_FNCT_CREATE',

  A_ENT_READ = 'A_ENT_READ',
  A_ENT_CREATE = 'A_ENT_CREATE',
  A_ENT_DELEGATION = 'A_ENT_DELEGATION',
  A_ENT_DELETE = 'A_ENT_DELETE',

  A_NUT_RIGHTS = 'A_NUT_RIGHT',
  A_REF_RIGHTS = 'A_REF_RIGHT',
  A_MOD_RIGHTS = 'A_MOD_RIGHT',
  A_MAT_RIGHTS = 'A_MAT_RIGHT',
  U_REF_RIGHT_READ = 'U_REF_RIGHT_READ',

  A_NUT_TRAD = 'A_NUT_TRAD',
  A_NUT_CLASS_TRAD = 'A_NUT_CLASS_TRAD',
  A_REF_TRAD = 'A_REF_TRAD',
  A_MOD_TRAD = 'A_MOD_TRAD',
  A_LVL_TRAD = 'A_LVL_TRAD',
  A_VAR_TRAD = 'A_VAR_TRAD',
  A_VAR_CLASS_TRAD = 'A_VAR_CLASS_TRAD',

  A_LVL_READ = 'A_LVL_READ',
  A_LVL_CREATE = 'A_LVL_CREATE',
  A_LVL_DELETE = 'A_LVL_DELETE',

  A_LANG_READ = 'A_LANG_READ',
  A_LANG_CREATE = 'A_LANG_CREATE',

  A_TRANS_LABEL_READ = 'A_TRANS_LABEL_READ',
  A_TRANS_LABEL_CREATE = 'A_TRANS_LABEL_CREATE',

  U_MP_CALCULATE = 'U_MP_CALCULATE',
  U_MP_CALCULATE_BATCH = 'U_MP_CALCULATE_BATCH',
  U_MP_DELETE = 'U_MP_DELETE',
  U_MP_EXPORT = 'U_MP_EXPORT',
  U_MP_EXPORT_SETTINGS = 'U_MP_EXPORT_SETTINGS',
  U_RM_DUP = "U_RM_DUP",
  U_MP_FULLAUTO_IMPORT_CREATE = "U_MP_FULLAUTO_IMPORT_CREATE",
  U_MP_FULLAUTO_IMPORT_MODIFY = "U_MP_FULLAUTO_IMPORT_MODIFY",
  U_MP_SEMIAUTO_IMPORT_CREATE = "U_MP_SEMIAUTO_IMPORT_CREATE",
  U_MP_SEMIAUTO_IMPORT_MODIFY = "U_MP_SEMIAUTO_IMPORT_MODIFY",
  U_RM_STATUS_FORCE = 'U_RM_STATUS_FORCE',
  U_TECHNICAL_DOC = 'U_TECHNICAL_DOC',
  U_MP_MASS_EDIT = 'U_MP_MASS_EDIT',
  U_MP_MASS_EDIT_VALUE = 'U_MP_MASS_EDIT_VALUE',

  A_MAT_READ = 'A_MAT_READ',
  A_MAT_CREATE = 'A_MAT_CREATE',
  A_MAT_DELETE = 'A_MAT_DELETE',

  U_MP_ENABLE_DISABLE = 'U_MP_ENABLE_DISABLE',
  U_MP_ARCHIVE = 'U_MP_ARCHIVE',
  U_MP_DESARCHIVE = 'U_MP_DESARCHIVE',

  A_FODDER_SAMPLE_ENABLE = "A_FODDER_SAMPLE_ENABLE",
  A_FODDER_SAMPLE_ARCHIVE = "A_FODDER_SAMPLE_ARCHIVE",
  A_FODDER_SAMPLE_DESARCHIVE = "A_FODDER_SAMPLE_DESARCHIVE",
  A_FODDER_SAMPLE_DELETE = "A_FODDER_SAMPLE_DELETE",

  U_SAMPLE_MODIFY = "U_SAMPLE_MODIFY",
  U_SAMPLE_CREATE = "U_SAMPLE_CREATE",
  U_SAMPLE_CALCULATE = "U_SAMPLE_CALCULATE",

  A_MP_SAMPLE_ENABLE = "A_MP_SAMPLE_ENABLE",
  A_MP_SAMPLE_ARCHIVE = "A_MP_SAMPLE_ARCHIVE",
  A_MP_SAMPLE_DESARCHIVE = "A_MP_SAMPLE_DESARCHIVE",
  A_MP_SAMPLE_DELETE = "A_MP_SAMPLE_DELETE",

  A_BULLETIN_TEMPLATE_CREATE = "A_BULLETIN_TEMPLATE_CREATE",
  A_BULLETIN_TEMPLATE_DELETE = "A_BULLETIN_TEMPLATE_DELETE",
  A_BULLETIN_TEMPLATE_READ = "A_BULLETIN_TEMPLATE_READ",

  A_SAMPLE_GROUP_CREATE = "A_SAMPLE_GROUP_CREATE",
  A_SAMPLE_GROUP_DELETE = "A_SAMPLE_GROUP_DELETE",
  A_SAMPLE_GROUP_READ = "A_SAMPLE_GROUP_READ",

  A_ENTITY_REFERENT = "A_ENTITY_REFERENT"
}
